import util from '../../lib/util';
import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import Privilege from '../../entities/privilege';
import Role from '../../entities/role';
export function deletePrivilege(privilege: Privilege, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = privilege.id;}
const _work = workingSet();
store.getState().roles.getMappingFor('privileges', privilege.id).filter(roleTemp => roleTemp.status !== 'D').forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.privileges = _role.privileges?.filter(id => id !== privilege.id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});



privilege.status = 'D';
privilege.addedOn = newHRTimestamp();
privilege.addedBy = getCurrentUserId();
privilege.importSource = targetImportSource;
privilege.importId = mergeId;
store.dispatch(Actions.PrivilegeActions.removePrivilegeQueue(privilege));
}
export function replacePrivilege(privilege: Privilege, replaceWith: Privilege, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = privilege.id;}
const _work = workingSet();
store.getState().roles.getMappingFor('privileges', privilege.id).filter(roleTemp => roleTemp.status !== 'D').forEach(roleTemp => {
const _role = ((_work.get('role:' + roleTemp.id) ?? roleTemp) as Role).clone();
_role.status = 'U';
_role.addedOn = newHRTimestamp();
_role.addedBy = getCurrentUserId();
_role.importSource = targetImportSource;
_role.importId = mergeId;
_role.privileges = _role.privileges?.map(id => (id === privilege.id) ? replaceWith.id : id) || [];

_work.set('role:' + _role.id, _role);
store.dispatch(Actions.RoleActions.saveRoleQueue(_role));
});



return privilege;
}
export function deleteImpactPrivilege(privilege: Privilege) {
const impacts: string[] = [];
const state = store.getState();
const rolePrivilegesImpact = state.roles.getMappingFor('privileges', privilege.id).filter(role => role.status !== 'D');
rolePrivilegesImpact.forEach(() => impacts.push('roles'));



return util.countDistinct(impacts);
}
